import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/codebuild/output/src2163433464/src/app/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2163433464/src/app/src/contexts/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyContextProvider"] */ "/codebuild/output/src2163433464/src/app/src/contexts/currency-context.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/components/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/containers/AuthContainer/AuthContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticatedUserIpRecorder"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/AuthenticatedUserIpRecorder.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/containers/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularTeamsList"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/PopularTeams/PopularTeamsList.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/containers/Search/Search.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/containers/UsageInstructionsSection/UsageInstructionsSection.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/ui/Tooltip/Tooltip.tsx");
